<template>
  <v-container fluid v-if="dataSource">
    <v-row no-gutters>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            {{ $t("servicesystem.common_objects.kpi.machine_kpi") }}
          </v-card-title>
          <v-toolbar flat>
            <v-select :label="$t('servicesystem.common_objects.commonterms.month')" :items="monthSelection"
              item-text="name" item-value="id" v-model="queryPreset.Month" hide-details dense :disabled="loading"
              @change="getByPreset(queryPreset)">
            </v-select>
            <v-select :label="$t('servicesystem.common_objects.commonterms.year')" :items="yearSelection"
              v-model="queryPreset.Year" hide-details dense :disabled="loading" @change="getByPreset(queryPreset)">
            </v-select>
            <v-select label="Selection" :items="groupSelection" v-model="queryPreset.GroupBy" hide-details dense
              :disabled="loading" @change="getByPreset(queryPreset)">
            </v-select>
            <v-select label="Status selection" :items="statusSelection" v-model="queryPreset.JobStatuses"
              :multiple="true" hide-details dense :disabled="loading" @change="getByPreset(queryPreset)">
            </v-select>
            <!-- 
            <v-divider vertical class="mx-2" />
            <v-btn color="primary">Export</v-btn>
            -->
          </v-toolbar>
          <v-card-text>
            <DxChart ref="chart">
              <DxTooltip :enabled="true" :customize-tooltip="customizeTooltip" />
              <DxAdaptiveLayout :width="450" />
              <DxSize :height="200" />
              <DxCommonSeriesSettings type="bar" />
            </DxChart>

            <DxPivotGrid id="pivotgrid" :height="500" ref="grid" :data-source="dataSource"
              :allow-sorting-by-summary="true" :allow-filtering="true" :show-borders="true"
              :show-column-grand-totals="false" :show-row-grand-totals="false" :show-row-totals="false"
              :show-column-totals="false">
              <DxFieldChooser :enabled="true" :height="400" />
            </DxPivotGrid>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import { DxAdaptiveLayout, DxChart, DxCommonSeriesSettings, DxSize, DxTooltip } from "devextreme-vue/chart";

import { DxFieldChooser, DxPivotGrid } from "devextreme-vue/pivot-grid";

import client from "@/api/client";
export default {
  name: "Graph",
  components: {
    DxChart,
    DxAdaptiveLayout,
    DxCommonSeriesSettings,
    DxPivotGrid,
    DxFieldChooser,
    DxSize,
    DxTooltip,
  },
  props: [],
  data() {
    return {
      loading: false,
      monthSelection: [],
      yearSelection: [],
      groupSelection: ["Closed", "Completed", "Planned", "Created"],
      statusSelection: ["Closed", "Completed", "Planned", "Created"],
      queryPreset: {
        JobStatuses: ['Completed'],
        VolumeDateType: 'Month',
        Month: (new Date()).getMonth() + 1,
        Year: (new Date()).getFullYear(),
        GroupBy: 'Completed'
      },
      dataSource: {
        fields: [],
        store: [],
      },
    };
  },
  mounted() {
    function monthName(month) {
      const dt = new Date();
      dt.setDate(1);
      dt.setMonth(month - 1);
      return dt.toLocaleDateString([], { month: 'long' })
    }
    for (let index = 1; index < 13; index++) {
      this.monthSelection.push({
        id: index,
        name: monthName(index)
      })
    }
    for (let index = 2020; index < (new Date().getFullYear() + 1); index++) {
      this.yearSelection.push(index)
    }

    this.getByPreset(this.queryPreset);
  },
  methods: {
    getByPreset(preset) {
      const statuses = 'JobStatuses=' + preset.JobStatuses.join('&JobStatuses=');
      client()
        .get(`/api2/serviceprovider/statistics/kpiMachineModel?${statuses}&VolumeDateType=${preset.VolumeDateType}&Month=${preset.Month}&GroupBy=${preset.GroupBy}&Year=${preset.Year}`)
        .then((response) => {
          if (!response.data) return;
          const data = {
            fields: [
              {
                caption: this.$t("servicesystem.common_objects.supplier.supplier"),
                dataField: "supplier",
                width: 350,
                area: "row",
              },
              {
                caption: this.$t("servicesystem.common_objects.model.model"),
                dataField: "machineModel",
                width: 250,
                area: "row",
              },
              {
                caption: this.$t("servicesystem.common_objects.customer.customer"),
                dataField: "customer",
                width: 250,
                area: "row",
              },
              {
                dataField: "date",
                dataType: "date",
                area: "column",
                groupInterval: "month"
              },
              {
                groupName: "supplier",
                visible: false,
              },
              {
                groupName: "customer",
                visible: false,
              },
              {
                caption: this.$t("servicesystem.common_objects.kpi.total"),
                dataField: "value",
                dataType: "formatter",
                summaryType: "sum",
                format: {
                  type: "currency",
                  precision: 2,
                  currency: this.$store.state.GlobalSettings.CurrencyFormat
                },
                area: "data",
              },
              {
                caption: this.$t("servicesystem.common_objects.commonterms.time"),
                dataField: "time",
                dataType: "number",
                summaryType: "sum",
                format: function (value) { return (new Date(value * 1000)).toUTCString().match(/(\d\d:\d\d:\d\d)/)[0]; },
                area: "data",
              },
            ],
            store: response.data.map((v) => {
              v.date = new Date(v.date);
              return v;
            }),
          };
          //console.log(data);
          this.dataSource = data;
          const pivotGrid = this.$refs.grid.instance;
          const chart = this.$refs.chart.instance;
          pivotGrid.bindChart(chart, {
            dataFieldsDisplayMode: "splitPanes",
            alternateDataFields: false,
          });
        });
    },
    customizeTooltip(args) {
      //console.log(args);
      return {
        text: `${this.$t("servicesystem.common_objects.commonterms.day")}: ${args.argumentText}<br/>
        ${this.$t("servicesystem.common_objects.model.model")}: ${args.seriesName}<br/>
        ${this.$t("servicesystem.common_objects.kpi.total")}: ${args.total}`
      }
    }
  },

  computed: {},

  watch: {},
};
</script>


<style lang='scss' scoped></style>